import { SortDirection } from '@openx/types/tableCriteria';

export function prepareSortAlphabeticallyHandler<T extends Record<string, unknown> | string>(
  extractValueFromItem: (item: T) => string | number,
  sortDirection: SortDirection
): (itemA: T, itemB: T) => number {
  return (itemA: T, itemB: T) => {
    let extractedAValue = extractValueFromItem(itemA);
    let extractedBValue = extractValueFromItem(itemB);

    if (Array.isArray(extractedAValue) && Array.isArray(extractedBValue)) {
      extractedAValue = Array.from(extractedAValue).sort(prepareSortAlphabeticallyHandler(v => v, sortDirection))[0];
      extractedBValue = Array.from(extractedBValue).sort(prepareSortAlphabeticallyHandler(v => v, sortDirection))[0];
    }

    if (typeof extractedAValue === 'string' && typeof extractedBValue === 'string') {
      return (sortDirection === SortDirection.ASC ? extractedAValue : extractedBValue).localeCompare(
        sortDirection === SortDirection.ASC ? extractedBValue : extractedAValue,
        'en',
        { sensitivity: 'accent' }
      );
    }

    return (
      Number(sortDirection === SortDirection.ASC ? extractedAValue : extractedBValue) -
      Number(sortDirection === SortDirection.ASC ? extractedBValue : extractedAValue)
    );
  };
}
